import { getInstancesBatch as apiGetInstancesBatch } from './api-client';

export async function getInstancesBatch(
    query,
    skip = 0,
    limit = 300,
    projection,
    sortArray
) {
    try {
        const sortedBatch = await apiGetInstancesBatch(query, skip, limit, projection, sortArray);
        return sortedBatch;
    } catch (error) {
        console.error("Error fetching batch of instances:", error);
        throw error;
    }
}